import comp from "./CollaboratorV2AddEditUserModal";
export default comp;
